import {
  createSelectorHooks,
  ZustandHookSelectors
} from 'auto-zustand-selectors-hook'
import create from 'zustand'

type Data = {
  orderId: string
  customerId: string
  subject?: string
  type?: string
  title?: any
  item?: {
    id: string
    sequence: string
  }
}

interface Order {
  data: Data
  isModalOpen: boolean
  setModalOpen: (open: boolean) => void
  setData: (data: Data) => void
}

const useStoreBase = create<Order>()((set) => ({
  data: {
    orderId: '',
    customerId: ''
  },
  isModalOpen: false,
  setModalOpen: (isModalOpen: boolean) => set(() => ({ isModalOpen })),
  setData: (data: Data) => set(() => ({ data }))
}))

export const useTrackingModalStore = createSelectorHooks(
  useStoreBase
) as typeof useStoreBase & ZustandHookSelectors<Order>
